import React from 'react';
import { Collapse } from 'reactstrap';
import Parser from 'html-react-parser';

class Legal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false
        }

        this.toggleOpen = this.toggleOpen.bind(this);
    }

    toggleOpen() {
        this.setState({ open: !this.state.open });
    }

    render() {
        return (
            <div className="section-page">
                <h3 className="mb-4" style={{ marginTop: '20px', cursor: 'pointer' }}>LEGAL</h3>
                {Parser(this.props.content.summary)}
                <div>
                    {!this.state.open &&
                        <span onClick={this.toggleOpen} style={{ cursor: 'pointer', color: '#BD2E2A' }}>read more...</span>
                    }
                </div>
                <Collapse isOpen={this.state.open}>
                    {Parser(this.props.content.full)}
                    <div>
                        {this.state.open &&
                            <span onClick={this.toggleOpen} style={{ cursor: 'pointer', color: '#BD2E2A' }}>read less...</span>
                        }
                    </div>
                </Collapse>
            </div>
        )
    }
}

export default Legal;


// WEBPACK FOOTER //
// ./src/views/Pages/Legal/legal.js